<div class="inner">
    <div class="label" *ngIf="txt!=null && txt.length>0">{{txt}}</div>
</div>